<div class="admin-container">
    <div class="admin-card">
        <div class="admin-header">
            <h2>{{'ADMIN.TITLE' | translate}}</h2>
            <button class="logout-btn" (click)="logout()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
                {{'ADMIN.LOGOUT' | translate}}
            </button>
        </div>

        <div class="admin-grid">
            <!-- Dashboard -->
            <a [routerLink]="dashboardPath" class="admin-tile">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="7" height="7"></rect>
                    <rect x="14" y="3" width="7" height="7"></rect>
                    <rect x="3" y="14" width="7" height="7"></rect>
                    <path d="M17.5 14v7M14 17.5h7"></path>
                </svg>
                <span class="tile-label">{{'ADMIN.DASHBOARD' | translate}}</span>
            </a>

            <!-- Fichas -->
            <a [routerLink]="fichasPath" class="admin-tile">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
                <span class="tile-label">{{'ADMIN.SHEETS' | translate}}</span>
            </a>
        </div>
    </div>
</div>
